import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalStorageManager } from '@cutting/main/shared/helper/local-storage-manager.helper';
import { fuseAnimations } from '@fuse/animations';
import { FuseConfigService } from '@fuse/services/config.service';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { ResetPasswordService } from './reset-password.service';

@Component({
  selector: 'fuse-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
  animations: fuseAnimations,
})
export class FuseResetPasswordComponent implements OnInit, OnDestroy {
  resetPasswordForm: UntypedFormGroup;
  resetPasswordFormErrors: any;
  resetPasswordKey = '';
  unsubscribe$: Subject<void> = new Subject();

  userOrign: string;

  constructor(
    private fuseConfigService: FuseConfigService,
    private formBuilder: UntypedFormBuilder,
    private activatedRoute: ActivatedRoute,
    private resetPasswordService: ResetPasswordService,
    private router: Router,
    private snackBar: MatSnackBar
  ) {
    this.fuseConfigService.config = {
      layout: {
        navbar: {
          hidden: true,
        },
        toolbar: {
          hidden: true,
        },
        footer: {
          hidden: true,
        },
        sidepanel: {
          hidden: true,
        },
      },
    };

    this.resetPasswordFormErrors = {
      password: {},
    };
  }

  ngOnInit(): void {
    this.resetPasswordForm = this.formBuilder.group({
      password: ['', [Validators.required, Validators.minLength(6)]],
    });

    this.resetPasswordForm.valueChanges.pipe(takeUntil(this.unsubscribe$)).subscribe(() => {
      this.onResetPasswordFormValuesChanged();
    });

    this.checkQueryParams();
  }

  onResetPasswordFormValuesChanged(): void {
    for (const field in this.resetPasswordFormErrors) {
      // Clear previous errors
      this.resetPasswordFormErrors[field] = {};

      // Get the control
      const control = this.resetPasswordForm.get(field);

      if (control && control.dirty && !control.valid) {
        this.resetPasswordFormErrors[field] = control.errors;
      }
    }
  }

  /*******************************************************************************************/

  onSubmit(): void {
    if (this.resetPasswordForm.valid) {
      this.resetPasswordService
        .setNewPassword(this.resetPasswordForm.controls.password.value, this.resetPasswordKey)
        .then(() => {
          this.router.navigate(['/client/auth/success-password-reset']);
          // if (this.userId) {
          //     this.router.navigate(['/client/auth/login'], { queryParams: { user: this.userId ? +this.userId : null } });
          // }
        })
        .catch(() => {
          this.snackBar.open($localize`Не удалось изменить пароль`);
        });
    }
  }

  checkQueryParams(): void {
    this.activatedRoute.queryParams.pipe(filter(params => params.key || params.userOrign)).subscribe(params => {
      if (params.userOrign) {
        this.userOrign = atob(params.userOrign);
      }

      // set key
      this.resetPasswordKey = '';

      const userId = LocalStorageManager.regData;

      if (!params.key) {
        this.router.navigate(['/client/auth/login'], { queryParams: { user: userId ? +userId : null } });
      }

      this.resetPasswordService
        .checkKeyForResetPass(params.key)
        .then(() => {
          this.resetPasswordKey = params.key;
        })
        .catch(() => {
          this.router.navigate(['/client/auth/login'], { queryParams: { user: userId ? +userId : null } });
        });
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
  }
}
